// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TrendingSpotlightSection_section__IgzPp {
  width: 100%;
  box-sizing: border-box;
  margin: 16px 0;
  padding: 16px;
  background: #fff;
}

.TrendingSpotlightSection_panel__mr91\\+ {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: #fff;
}

.TrendingSpotlightSection_header__KXu1S {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
}

.TrendingSpotlightSection_copy__KVW1y {
  min-width: 0;
  max-width: 640px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.TrendingSpotlightSection_titleRow__wuGfm {
  display: flex;
  align-items: center;
  gap: 10px;
}

.TrendingSpotlightSection_titleIcon__2v3I4 {
  flex-shrink: 0;
}

.TrendingSpotlightSection_title__GvZy4 {
  margin: 0;
  color: #121826;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;
  font-size: 34px;
  font-weight: 750;
  line-height: 1.1;
  letter-spacing: -0.03em;
}

.TrendingSpotlightSection_description__KgIYP {
  margin: 0;
  color: #6b7280;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.5;
}

.TrendingSpotlightSection_controls__xLm8d {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
  padding-bottom: 4px;
}

.TrendingSpotlightSection_counter__R7rY1 {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #121826;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.TrendingSpotlightSection_counterTrack__62UjG {
  width: 42px;
  height: 3px;
  border-radius: 999px;
  background: #d7dde6;
  position: relative;
  overflow: hidden;
}

.TrendingSpotlightSection_counterFill__vwomm {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  background: #1493d4;
  border-radius: inherit;
}

.TrendingSpotlightSection_arrow__GFTpK {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #e4e7ee;
  background: #fff;
  color: #121826;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  font-size: 22px;
  line-height: 1;
}

.TrendingSpotlightSection_arrow__GFTpK:disabled {
  color: #c5cad3;
  cursor: not-allowed;
}

.TrendingSpotlightSection_stage__jVS9a {
  display: flex;
  gap: 32px;
  width: 100%;
  align-items: stretch;
}

.TrendingSpotlightSection_hero__1KX6j {
  position: relative;
  flex: 0 0 50%;
  width: 100%;
  max-width: 460px;
  aspect-ratio: 1.029;
  border-radius: 12px;
  overflow: clip;
  cursor: pointer;
  background: #e8e9ed;
}

.TrendingSpotlightSection_heroPhoto__B7Kxv {
  position: absolute;
  inset: 0;
  transition: opacity 0.5s ease-in-out;
}

.TrendingSpotlightSection_heroPhotoCurrent__9cBcf {
  opacity: 1;
  z-index: 2;
}

.TrendingSpotlightSection_heroPhotoPrevious__t-tDC {
  opacity: 0;
  z-index: 1;
  pointer-events: none;
}

.TrendingSpotlightSection_heroCopy__LNg\\+3 {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 3;
  color: #fff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.TrendingSpotlightSection_heroTitle__vtt9q {
  margin: 0 0 8px;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;
  font-size: 1.8rem;
  font-weight: 700;
}

.TrendingSpotlightSection_heroCountry__HtyFl {
  margin: 0;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;
  font-size: 1rem;
  opacity: 0.9;
}

.TrendingSpotlightSection_heroNav__yGf5Z {
  position: absolute;
  left: 20px;
  right: 20px;
  bottom: 20px;
  z-index: 3;
  display: flex;
  justify-content: space-between;
}

.TrendingSpotlightSection_details__e01mw {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.TrendingSpotlightSection_cityRow__bUqNN {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.TrendingSpotlightSection_city__vZKGH {
  margin: 0;
  color: #16161d;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;
  font-size: 1.85rem;
  font-weight: 700;
  letter-spacing: -0.025em;
  line-height: 1.15;
}

.TrendingSpotlightSection_cityDescription__HkAo- {
  margin: 0;
  color: #5e616e;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;
  font-size: 0.95rem;
  line-height: 1.55;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.TrendingSpotlightSection_explore__rAxWI {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 40px;
  height: 40px;
  padding: 0 16px;
  border: 0;
  border-radius: 10px;
  background: #16161d;
  color: #fff;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.1px;
  cursor: pointer;
}

.TrendingSpotlightSection_explore__rAxWI:hover {
  background: #2c2c36;
}

.TrendingSpotlightSection_moreLabel__l-SxW {
  margin: 8px 0 0;
  color: #16161d;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.TrendingSpotlightSection_thumbs__MRgFB {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.TrendingSpotlightSection_thumb__RJ48A {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  border: 0;
  border-radius: 16px;
  overflow: clip;
  cursor: pointer;
  background: #e8e9ed;
  aspect-ratio: 16 / 11;
}

.TrendingSpotlightSection_thumbPhoto__KJ\\+4A {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.TrendingSpotlightSection_thumbActive__W1Cfi {
  box-shadow: inset 0 0 0 2px #000;
}

.TrendingSpotlightSection_shimmerCopy__XjsiB {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

@media (min-width: 900px) {
  .TrendingSpotlightSection_section__IgzPp {
    padding: 24px clamp(20px, 1.25vw, 40px);
  }

  .TrendingSpotlightSection_panel__mr91\\+ {
    max-width: 1200px;
    gap: 16px;
  }

  .TrendingSpotlightSection_thumbs__MRgFB {
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
  }
}

@media (min-width: 1200px) {
  .TrendingSpotlightSection_section__IgzPp {
    padding: 28px clamp(24px, 1.25vw, 48px);
  }

  .TrendingSpotlightSection_panel__mr91\\+ {
    max-width: 1400px;
    gap: 18px;
  }

  .TrendingSpotlightSection_details__e01mw {
    min-height: 0;
  }

  .TrendingSpotlightSection_thumbs__MRgFB {
    flex: 1 1;
    grid-auto-rows: 1fr;
  }

  .TrendingSpotlightSection_thumb__RJ48A {
    height: 100%;
    aspect-ratio: auto;
  }
}

@media (min-width: 1536px) {
  .TrendingSpotlightSection_section__IgzPp {
    padding: 32px clamp(24px, 1.25vw, 48px);
  }

  .TrendingSpotlightSection_panel__mr91\\+ {
    max-width: 1600px;
    gap: 20px;
  }
}

@media (max-width: 1199px) {
  .TrendingSpotlightSection_stage__jVS9a {
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .TrendingSpotlightSection_hero__1KX6j {
    flex-basis: auto;
    align-self: center;
  }

  .TrendingSpotlightSection_details__e01mw {
    width: 100%;
  }
}

@media (max-width: 1100px) {
  .TrendingSpotlightSection_title__GvZy4,
  .TrendingSpotlightSection_city__vZKGH {
    font-size: 28px;
  }
}

@media (max-width: 700px) {
  .TrendingSpotlightSection_header__KXu1S {
    flex-direction: column;
    align-items: flex-start;
  }

  .TrendingSpotlightSection_controls__xLm8d {
    display: none;
  }

  .TrendingSpotlightSection_cityRow__bUqNN {
    align-items: flex-start;
    gap: 12px;
  }

  .TrendingSpotlightSection_cityDescription__HkAo- {
    font-size: 0.85rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Homepage/TrendingSpotlightSection.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gEAAgE;EAChE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gEAAgE;EAChE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gEAAgE;EAChE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gEAAgE;EAChE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gEAAgE;EAChE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gEAAgE;EAChE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gEAAgE;EAChE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gEAAgE;EAChE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gEAAgE;EAChE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,uCAAuC;EACzC;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAO;IACP,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".section {\n  width: 100%;\n  box-sizing: border-box;\n  margin: 16px 0;\n  padding: 16px;\n  background: #fff;\n}\n\n.panel {\n  width: 100%;\n  max-width: 100%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  background: #fff;\n}\n\n.header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 24px;\n}\n\n.copy {\n  min-width: 0;\n  max-width: 640px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.titleRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.titleIcon {\n  flex-shrink: 0;\n}\n\n.title {\n  margin: 0;\n  color: #121826;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;\n  font-size: 34px;\n  font-weight: 750;\n  line-height: 1.1;\n  letter-spacing: -0.03em;\n}\n\n.description {\n  margin: 0;\n  color: #6b7280;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 1.5;\n}\n\n.controls {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-shrink: 0;\n  padding-bottom: 4px;\n}\n\n.counter {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #121826;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n}\n\n.counterTrack {\n  width: 42px;\n  height: 3px;\n  border-radius: 999px;\n  background: #d7dde6;\n  position: relative;\n  overflow: hidden;\n}\n\n.counterFill {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  background: #1493d4;\n  border-radius: inherit;\n}\n\n.arrow {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 1px solid #e4e7ee;\n  background: #fff;\n  color: #121826;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  font-size: 22px;\n  line-height: 1;\n}\n\n.arrow:disabled {\n  color: #c5cad3;\n  cursor: not-allowed;\n}\n\n.stage {\n  display: flex;\n  gap: 32px;\n  width: 100%;\n  align-items: stretch;\n}\n\n.hero {\n  position: relative;\n  flex: 0 0 50%;\n  width: 100%;\n  max-width: 460px;\n  aspect-ratio: 1.029;\n  border-radius: 12px;\n  overflow: clip;\n  cursor: pointer;\n  background: #e8e9ed;\n}\n\n.heroPhoto {\n  position: absolute;\n  inset: 0;\n  transition: opacity 0.5s ease-in-out;\n}\n\n.heroPhotoCurrent {\n  opacity: 1;\n  z-index: 2;\n}\n\n.heroPhotoPrevious {\n  opacity: 0;\n  z-index: 1;\n  pointer-events: none;\n}\n\n.heroCopy {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  z-index: 3;\n  color: #fff;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);\n}\n\n.heroTitle {\n  margin: 0 0 8px;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;\n  font-size: 1.8rem;\n  font-weight: 700;\n}\n\n.heroCountry {\n  margin: 0;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;\n  font-size: 1rem;\n  opacity: 0.9;\n}\n\n.heroNav {\n  position: absolute;\n  left: 20px;\n  right: 20px;\n  bottom: 20px;\n  z-index: 3;\n  display: flex;\n  justify-content: space-between;\n}\n\n.details {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.cityRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.city {\n  margin: 0;\n  color: #16161d;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;\n  font-size: 1.85rem;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  line-height: 1.15;\n}\n\n.cityDescription {\n  margin: 0;\n  color: #5e616e;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;\n  font-size: 0.95rem;\n  line-height: 1.55;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.explore {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 40px;\n  height: 40px;\n  padding: 0 16px;\n  border: 0;\n  border-radius: 10px;\n  background: #16161d;\n  color: #fff;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  cursor: pointer;\n}\n\n.explore:hover {\n  background: #2c2c36;\n}\n\n.moreLabel {\n  margin: 8px 0 0;\n  color: #16161d;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;\n  font-size: 1.05rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n}\n\n.thumbs {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n}\n\n.thumb {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  border: 0;\n  border-radius: 16px;\n  overflow: clip;\n  cursor: pointer;\n  background: #e8e9ed;\n  aspect-ratio: 16 / 11;\n}\n\n.thumbPhoto {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.thumbActive {\n  box-shadow: inset 0 0 0 2px #000;\n}\n\n.shimmerCopy {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n@media (min-width: 900px) {\n  .section {\n    padding: 24px clamp(20px, 1.25vw, 40px);\n  }\n\n  .panel {\n    max-width: 1200px;\n    gap: 16px;\n  }\n\n  .thumbs {\n    grid-template-columns: repeat(4, 1fr);\n    gap: 16px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .section {\n    padding: 28px clamp(24px, 1.25vw, 48px);\n  }\n\n  .panel {\n    max-width: 1400px;\n    gap: 18px;\n  }\n\n  .details {\n    min-height: 0;\n  }\n\n  .thumbs {\n    flex: 1;\n    grid-auto-rows: 1fr;\n  }\n\n  .thumb {\n    height: 100%;\n    aspect-ratio: auto;\n  }\n}\n\n@media (min-width: 1536px) {\n  .section {\n    padding: 32px clamp(24px, 1.25vw, 48px);\n  }\n\n  .panel {\n    max-width: 1600px;\n    gap: 20px;\n  }\n}\n\n@media (max-width: 1199px) {\n  .stage {\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n  }\n\n  .hero {\n    flex-basis: auto;\n    align-self: center;\n  }\n\n  .details {\n    width: 100%;\n  }\n}\n\n@media (max-width: 1100px) {\n  .title,\n  .city {\n    font-size: 28px;\n  }\n}\n\n@media (max-width: 700px) {\n  .header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .controls {\n    display: none;\n  }\n\n  .cityRow {\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .cityDescription {\n    font-size: 0.85rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `TrendingSpotlightSection_section__IgzPp`,
	"panel": `TrendingSpotlightSection_panel__mr91+`,
	"header": `TrendingSpotlightSection_header__KXu1S`,
	"copy": `TrendingSpotlightSection_copy__KVW1y`,
	"titleRow": `TrendingSpotlightSection_titleRow__wuGfm`,
	"titleIcon": `TrendingSpotlightSection_titleIcon__2v3I4`,
	"title": `TrendingSpotlightSection_title__GvZy4`,
	"description": `TrendingSpotlightSection_description__KgIYP`,
	"controls": `TrendingSpotlightSection_controls__xLm8d`,
	"counter": `TrendingSpotlightSection_counter__R7rY1`,
	"counterTrack": `TrendingSpotlightSection_counterTrack__62UjG`,
	"counterFill": `TrendingSpotlightSection_counterFill__vwomm`,
	"arrow": `TrendingSpotlightSection_arrow__GFTpK`,
	"stage": `TrendingSpotlightSection_stage__jVS9a`,
	"hero": `TrendingSpotlightSection_hero__1KX6j`,
	"heroPhoto": `TrendingSpotlightSection_heroPhoto__B7Kxv`,
	"heroPhotoCurrent": `TrendingSpotlightSection_heroPhotoCurrent__9cBcf`,
	"heroPhotoPrevious": `TrendingSpotlightSection_heroPhotoPrevious__t-tDC`,
	"heroCopy": `TrendingSpotlightSection_heroCopy__LNg+3`,
	"heroTitle": `TrendingSpotlightSection_heroTitle__vtt9q`,
	"heroCountry": `TrendingSpotlightSection_heroCountry__HtyFl`,
	"heroNav": `TrendingSpotlightSection_heroNav__yGf5Z`,
	"details": `TrendingSpotlightSection_details__e01mw`,
	"cityRow": `TrendingSpotlightSection_cityRow__bUqNN`,
	"city": `TrendingSpotlightSection_city__vZKGH`,
	"cityDescription": `TrendingSpotlightSection_cityDescription__HkAo-`,
	"explore": `TrendingSpotlightSection_explore__rAxWI`,
	"moreLabel": `TrendingSpotlightSection_moreLabel__l-SxW`,
	"thumbs": `TrendingSpotlightSection_thumbs__MRgFB`,
	"thumb": `TrendingSpotlightSection_thumb__RJ48A`,
	"thumbPhoto": `TrendingSpotlightSection_thumbPhoto__KJ+4A`,
	"thumbActive": `TrendingSpotlightSection_thumbActive__W1Cfi`,
	"shimmerCopy": `TrendingSpotlightSection_shimmerCopy__XjsiB`
};
export default ___CSS_LOADER_EXPORT___;
